import type { Schema } from "@/shared/components/Form/types";
import { OrganizationsAutocompleteQuery } from "@/admin/entities/organizations";
import { REVENUE_SHARE_REPORT_STATUS_LABEL } from "../domains/billingLabels";

export const filterSchema: Schema = {
  status: {
    label: "Статус",
    type: "select",
    priority: "quick",
    xs: 12,
    options: [
      { label: "Все", value: "" },
      ...Object.entries(REVENUE_SHARE_REPORT_STATUS_LABEL).map(
        ([value, label]) => ({ label, value })
      ),
    ],
  },
  period: {
    label: "Месяц",
    helperText: "Формат YYYY-MM, например 2026-09",
    type: "text",
    xs: 12,
    md: 3,
    fullWidth: true,
    priority: "secondary",
  },
  organizationId: {
    label: "Организация",
    type: "autocomplete",
    query: OrganizationsAutocompleteQuery,
    xs: 12,
    md: 3,
    fullWidth: true,
    priority: "secondary",
  },
};

/** Пустые значения в фильтр не уходят (см. paymentsSchemas). */
export function normalizeFilter(
  filter: Record<string, unknown>
): Record<string, unknown> {
  const normalized: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(filter)) {
    if (value === "" || value === null || value === undefined) continue;
    normalized[key] = value;
  }
  return normalized;
}
